import {of} from 'rxjs';
import {ReceptionService} from '../_services';
import {catchError, finalize, tap} from 'rxjs/operators';
import {BaseDataSource} from '@core/models/data-source/_base.datasource';
import {QueryParamsModel} from '@core/models/query-models/query-params.model';
import {QueryResultsModel} from '@core/models/query-models/query-results.model';

export class ReceptionDataSource extends BaseDataSource {

    constructor(private receptionService: ReceptionService) {
        super();
    }

    loadReceptions(
        queryParams: QueryParamsModel
    ) {
        this.loadingSubject.next(true);
        this.receptionService.findReceptions(queryParams).pipe(
            tap(res => {
                this.entitySubject.next(res.results);
                this.paginatorTotalSubject.next(res.total);
            }),
            catchError(err => of(new QueryResultsModel([], err))),
            finalize(() => this.loadingSubject.next(false))
        ).subscribe();
    }
}
